import AppLayout from "components/Layout/AppLayout";
import { useRoutes } from "react-router-dom";
import routes from "routes";

const AppRoutes = () => {
  const appRoutes = useRoutes([
    ...routes.map((route) => {
      return {
        path: route.path,
        element: (
          <AppLayout authState={route?.authState} title={route?.title}>
            {route.element}
          </AppLayout>
        ),
      };
    }),
  ]);
  return appRoutes;
};

export default AppRoutes;
